export class TargetURL {
  get() {
    return process.env.REACT_APP_API
  }
}
